module.exports = __webpack_public_path__ + "img/hand-flower.985b4444.jpeg";